import { Button, Table } from "@mui/joy";
import React from "react";
import NotesDialog from "../Dialogs/NotesDialog";
import { Util } from "../Helpers/Util";
interface NotesListingProps {
	buildingId: string;
}

interface Note {
	buildings_id: string;
	created_by: string;
	created_date: string;
	description: string;
	notes_id: string;
	title: string;
}

export default function NotesListing(props: NotesListingProps) {
	const [notes, setNotes] = React.useState([] as Array<Note>);
	const [dialog, setDialog] = React.useState(false);
	const [nId, setNId] = React.useState("");

	React.useEffect(() => {
		getData();
	}, [props.buildingId]);

	const getData = () => {
		setDialog(false);
		fetch("Building/GetNotes", {
			method: "Post",
			cache: "no-cache",
			headers: {
				"Content-Type": "application/json",
			},
			body: JSON.stringify({ buildingsId: props.buildingId }),
		})
			.then((x) => x.json())
			.then((x) => setNotes(x as Array<Note>));
	};
	return (
		<>
			{dialog && <NotesDialog buildingId={props.buildingId} notesId={nId} close={getData} />}
			<Button
				sx={{ mt: 1 }}
				onClick={() => {
					setNId("");
					setDialog(true);
				}}>
				Add Note
			</Button>{" "}
			<Table stickyHeader sx={{ overflowY: "auto" }} stripe="even" hoverRow>
				<thead>
					<tr>
						<th>Title</th>
						<th>Description</th>
						<th>Created By</th>
						<th>Date Created </th>
					</tr>
				</thead>
				<tbody>
					{notes.map((x) => {
						return (
							<tr
								style={{ cursor: "pointer" }}
								onClick={() => {
									setNId(x.notes_id);
									setDialog(true);
								}}>
								<td>{x.title}</td>
								<td>{x.description}</td>
								<td>{x.created_by}</td>
								<td>{Util.Formatter(x.created_date, "D")}</td>
							</tr>
						);
					})}
				</tbody>
			</Table>
		</>
	);
}
